export var PartStatus;
(function (PartStatus) {
    PartStatus[PartStatus["EVENT_NEEDS_ACTION"] = 1] = "EVENT_NEEDS_ACTION";
    PartStatus[PartStatus["EVENT_ACCEPTED"] = 2] = "EVENT_ACCEPTED";
    PartStatus[PartStatus["EVENT_DECLINED"] = 3] = "EVENT_DECLINED";
    PartStatus[PartStatus["EVENT_TENTATIVE"] = 4] = "EVENT_TENTATIVE";
    PartStatus[PartStatus["EVENT_DELEGATED"] = 5] = "EVENT_DELEGATED";
})(PartStatus || (PartStatus = {}));
export var InviteType;
(function (InviteType) {
    InviteType[InviteType["ORGANIZER"] = 1] = "ORGANIZER";
    InviteType[InviteType["INVITEE"] = 2] = "INVITEE";
})(InviteType || (InviteType = {}));
export var TimeUnit;
(function (TimeUnit) {
    TimeUnit[TimeUnit["MIN"] = 1] = "MIN";
    TimeUnit[TimeUnit["HOUR"] = 2] = "HOUR";
    TimeUnit[TimeUnit["DAY"] = 3] = "DAY";
    TimeUnit[TimeUnit["WEEK"] = 4] = "WEEK";
})(TimeUnit || (TimeUnit = {}));
export var EnumRange;
(function (EnumRange) {
    EnumRange[EnumRange["THIS"] = 1] = "THIS";
    EnumRange[EnumRange["THIS_AND_FUTURE"] = 2] = "THIS_AND_FUTURE";
    EnumRange[EnumRange["ALL"] = 3] = "ALL";
})(EnumRange || (EnumRange = {}));
export var ScheduleSendMailEnum;
(function (ScheduleSendMailEnum) {
    ScheduleSendMailEnum[ScheduleSendMailEnum["SEND"] = 1] = "SEND";
    ScheduleSendMailEnum[ScheduleSendMailEnum["NOT_SEND"] = 2] = "NOT_SEND";
})(ScheduleSendMailEnum || (ScheduleSendMailEnum = {}));
export var CatalogPrivilege;
(function (CatalogPrivilege) {
    CatalogPrivilege[CatalogPrivilege["RESERVE"] = 0] = "RESERVE";
    CatalogPrivilege[CatalogPrivilege["NONE"] = 1] = "NONE";
    CatalogPrivilege[CatalogPrivilege["BUSY"] = 2] = "BUSY";
    CatalogPrivilege[CatalogPrivilege["VIEW"] = 3] = "VIEW";
    CatalogPrivilege[CatalogPrivilege["OPREATE"] = 4] = "OPREATE";
})(CatalogPrivilege || (CatalogPrivilege = {}));
export var ScheduleClazz;
(function (ScheduleClazz) {
    ScheduleClazz[ScheduleClazz["DEFAULT"] = 0] = "DEFAULT";
    ScheduleClazz[ScheduleClazz["PUBLIC"] = 1] = "PUBLIC";
    ScheduleClazz[ScheduleClazz["PRIVATE"] = 2] = "PRIVATE";
    ScheduleClazz[ScheduleClazz["CONFIDENTIAL"] = 3] = "CONFIDENTIAL";
})(ScheduleClazz || (ScheduleClazz = {}));
export var ScheduleSyncObInitiator;
(function (ScheduleSyncObInitiator) {
    ScheduleSyncObInitiator["MAIN_MODULE"] = "MAIN_MODULE";
    ScheduleSyncObInitiator["MODAL_MODULE"] = "MODAL_MODULE";
    ScheduleSyncObInitiator["IM_MODULE"] = "IM_MODULE";
    ScheduleSyncObInitiator["INDEPENDED_MODULE"] = "INDEPENDED_MODULE";
    ScheduleSyncObInitiator["MAIL_MODULE"] = "MAIL_MODULE";
})(ScheduleSyncObInitiator || (ScheduleSyncObInitiator = {}));
